import { createFileRoute, redirect } from '@tanstack/react-router'
import { PerformancePage } from '../pages/PerformancePage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/performance' as any)({
    component: PerformancePage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
